import React from "react";

interface CustomerCareCallsData {
  benchmark: string; under7Completed: string; totalCallsCompleted: string;
  percentCompletedUnder7: string; bonusPercentEarned: string; bonusValue: string; score: string;
}
interface PayoutTier { actual: string; payout: string; }
interface CustomerCareCallsDCCMSubFormProps {
  data: CustomerCareCallsData; isEditable: boolean; payoutTiers: PayoutTier[];
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>, options?: { type?: 'number' | 'decimal' | 'text'; maxLength?: number; minLength?: number; max?: number; min?: number }) => void;
}

const CustomerCareCallsDCCMSubForm: React.FC<CustomerCareCallsDCCMSubFormProps> = ({ data, isEditable, payoutTiers, onInputChange }) => {
  const fmt = (v: string) => v && v !== "" && !isNaN(Number(v)) ? parseInt(v).toString() : "";
  return (
    <div className="sf-section">
      <h3 className="sf-title">Customer Care Calls (70% of total achievement score)</h3>
      <p className="sf-subtitle">This will be evaluated from calls completed within 7 days. The goal is 70% of all calls completed within 7 days.</p>
      <div className="grid grid-cols-2 gap-6">
        <div className="space-y-4">
          {[
            { label: "Under 7 Completed", name: "customerExperience.customerCareCalls.under7Completed", value: data.under7Completed },
            { label: "Total Calls Completed", name: "customerExperience.customerCareCalls.totalCallsCompleted", value: data.totalCallsCompleted },
          ].map(f => (
            <div key={f.name}>
              <label className="sf-label">{f.label}</label>
              <input type="number" name={f.name} value={f.value} inputMode="numeric" maxLength={4} minLength={1}
                disabled={!isEditable} onChange={e => onInputChange(e, { type: "number", maxLength: 4, minLength: 1 })}
                onFocus={e => e.target.select()} className="sf-input mt-1 block w-full px-3 py-2 text-right" />
            </div>
          ))}
          <div>
            <label className="sf-label">% Completed Under 7</label>
            <div className="relative mt-1">
              <input type="number" readOnly name="customerExperience.customerCareCalls.percentCompletedUnder7"
                value={fmt(data.percentCompletedUnder7)} className="sf-input-ro block w-full px-3 py-2 pr-8 text-right" />
              <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm" style={{ color: "var(--text-muted)" }}>%</span>
            </div>
          </div>
        </div>
        <table className="sf-table self-start">
          <thead><tr><th>Actual %</th><th>% Pay Out</th></tr></thead>
          <tbody>{payoutTiers.map((tier, i) => <tr key={i}><td>{tier.actual}</td><td>{tier.payout}</td></tr>)}</tbody>
        </table>
      </div>
      <div className="sf-results grid grid-cols-4 gap-4">
        {[
          { label: "Bonus % Earned", name: "customerExperience.customerCareCalls.bonusPercentEarned", value: data.bonusPercentEarned },
          { label: "70%", name: "customerExperience.customerCareCalls.bonusValue", value: data.bonusValue },
          { label: "Score", name: "customerExperience.customerCareCalls.score", value: data.score },
        ].map(f => (
          <div key={f.name}>
            <div className="sf-results-label">{f.label}</div>
            <input type="text" readOnly name={f.name} value={f.value} className="sf-input-ro mt-1 w-24 px-2 py-1 text-right" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerCareCallsDCCMSubForm;